import React from 'react';
import UploadContent from './UploadContent';

const Vault = () => {
    return <UploadContent type='Vault'/>;
};

export default Vault;